import(/* webpackMode: "eager", webpackExports: ["RealtimeProviderMount"] */ "/app/apps/admin-web/src/lib/realtime/RealtimeProviderMount.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/admin-web/src/app/generated-tokens.css");
;
import(/* webpackMode: "eager" */ "/app/apps/admin-web/src/app/generated-density.css");
;
import(/* webpackMode: "eager" */ "/app/apps/admin-web/src/app/generated-typography.css");
;
import(/* webpackMode: "eager" */ "/app/apps/admin-web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DevToolsErrorSuppressor"] */ "/app/packages/admin-frontend/src/components/DevToolsErrorSuppressor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppLinkOpener"] */ "/app/packages/admin-frontend/src/components/native/AppLinkOpener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeAppMarker"] */ "/app/packages/admin-frontend/src/components/native/NativeAppMarker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistrar"] */ "/app/packages/admin-frontend/src/components/offline/ServiceWorkerRegistrar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/admin-frontend/src/components/PostHogInit.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/spinner.css");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/skeleton.css");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/reduced-motion.css");
